import styles from './HtzBauteilIndexConflictTable.module.css';
import { useLanguageContextAPI } from '../../../shared/context/LanguageContext';

type Props = {
  rows: { htz: string; bauteilindex: string }[];
};

export default function HtzBauteilIndexConflictTable({ rows }: Props) {
  const { t } = useLanguageContextAPI();

  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.rowStyle}>HTZ</th>
            <th className={styles.rowStyle}>{t('npiSteering.bauteilindex')}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={`${row.htz}-${row.bauteilindex}-${index}`}>
              <td className={styles.rowStyle}>{row.htz}</td>
              <td className={styles.rowStyle}>{row.bauteilindex}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
